import { IconProps } from "@/common/contracts/icon.contracts";

export const ShippingBoxSecure = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_13840_36394)">
        <path
          d="M21 16.4805C21 16.8605 20.79 17.1905 20.47 17.3605L12.57 21.8005C12.41 21.9205 12.21 21.9805 12 21.9805C11.79 21.9805 11.59 21.9205 11.43 21.8005L3.53 17.3605C3.21 17.1905 3 16.8605 3 16.4805V7.48047C3 7.10047 3.21 6.77047 3.53 6.60047L11.43 2.16047C11.59 2.04047 11.79 1.98047 12 1.98047C12.21 1.98047 12.41 2.04047 12.57 2.16047L20.47 6.60047C20.79 6.77047 21 7.10047 21 7.48047V16.4805ZM12 4.13047L10.11 5.20047L16 8.59047L17.96 7.48047L12 4.13047ZM6.04 7.48047L12 10.8305L13.96 9.73047L8.08 6.33047L6.04 7.48047ZM5 15.8905L11 19.2705V12.5605L5 9.19047V15.8905ZM19 15.8905V9.19047L13 12.5605V19.2705L19 15.8905Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.315 16.2596L19.0986 15.0477C19.3014 14.9581 19.54 14.9581 19.7428 15.0477L22.5265 16.2596C22.8128 16.3843 22.9997 16.6649 22.9997 16.9727V18.8043C22.9997 20.967 21.4727 22.9895 19.4207 23.4805C17.3688 22.9895 15.8418 20.967 15.8418 18.8043V16.9727C15.8418 16.6649 16.0287 16.3843 16.315 16.2596ZM17.3136 19.8564L18.3435 20.8657C18.4986 21.0177 18.7531 21.0177 18.9042 20.8657L21.5248 18.2977C21.6799 18.1457 21.6799 17.9002 21.5248 17.7482C21.3697 17.5962 21.1192 17.5962 20.9641 17.7482L18.6259 20.0395L17.8743 19.3069C17.7192 19.155 17.4687 19.155 17.3136 19.3069C17.2391 19.3797 17.1973 19.4786 17.1973 19.5817C17.1973 19.6847 17.2391 19.7836 17.3136 19.8564Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_13840_36394">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
